import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "UI/Box";
import { Button } from "UI/Button";
import { Modal } from "UI/Modal";
import { Typography } from "UI/Typography";

type Props = {
  parentId: number;
  searchedId: string;
  onClose: () => void;
};

export const ModalPaymentAttemptFound = ({
  parentId,
  searchedId,
  onClose,
}: Props): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal open hideHeader width={480} onClose={onClose}>
      <Box p={27} style={{ textAlign: "center" }}>
        <Typography variant="h4" mb={16}>
          {t("Найдена связанная транзакция")}
        </Typography>
        <Typography
          variant="subtitle2"
          mt={8}
          mb={32}
          style={{ color: "#393939" }}
        >
          {t(
            "Транзакция {{child_transaction_id}} является дочерней и относится к основной транзакции {{parent_transaction_id}}, которая показана ниже.",
            {
              child_transaction_id: searchedId,
              parent_transaction_id: parentId,
            }
          )}
        </Typography>
        <Button size="small" fullwidth onClick={onClose}>
          {t("Закрыть")}
        </Button>
      </Box>
    </Modal>
  );
};
